import { c as _c } from "react/compiler-runtime";
import { Folder } from 'lucide-react';
import type { ImportQueueItem } from '../types/import-queue-item';
import type { ImportQueueStatus } from '../types/import-queue-status';
import type { ImportTreeNode } from '../utils/build-import-tree';
import { ImportQueueRow } from './import-queue-row';
interface ImportQueueTreeProps {
  nodes: ImportTreeNode[];
  activeNavigationId?: string;
  statusLabelOverride?: Partial<Record<ImportQueueStatus, string>>;
  onItemClick?: (item: ImportQueueItem) => void;
  onRetry: (clientId: string) => void;
}
export function ImportQueueTree(t0) {
  const $ = _c(13);
  const {
    nodes,
    activeNavigationId,
    statusLabelOverride,
    onItemClick,
    onRetry
  } = t0;
  let t1;
  if ($[0] !== activeNavigationId || $[1] !== nodes || $[2] !== onItemClick || $[3] !== onRetry || $[4] !== statusLabelOverride) {
    let t2;
    if ($[6] !== activeNavigationId || $[7] !== onItemClick || $[8] !== onRetry || $[9] !== statusLabelOverride) {
      t2 = (node, i) => {
        if (node.kind === "folder") {
          return <li key={`folder-${node.name}-${node.depth}-${i}`}><div className="text-muted-foreground flex items-center gap-1.5 px-3 pt-2 pb-0.5 text-xs font-semibold" style={{
              paddingLeft: `${node.depth * 12 + 12}px`
            }}><Folder className="size-3.5 shrink-0" aria-hidden={true} /><span className="truncate">{node.name}</span></div><ul><ImportQueueTree nodes={node.children} activeNavigationId={activeNavigationId} statusLabelOverride={statusLabelOverride} onItemClick={onItemClick} onRetry={onRetry} /></ul></li>;
        }
        const {
          item
        } = node;
        const isActive = Boolean(item.navigationId && activeNavigationId && item.navigationId === activeNavigationId);
        return <li key={item.clientId}><ImportQueueRow item={item} depth={node.depth} isActive={isActive} statusLabelOverride={statusLabelOverride} onClick={onItemClick ? () => onItemClick(item) : undefined} onRetry={onRetry} /></li>;
      };
      $[6] = activeNavigationId;
      $[7] = onItemClick;
      $[8] = onRetry;
      $[9] = statusLabelOverride;
      $[10] = t2;
    } else {
      t2 = $[10];
    }
    t1 = nodes.map(t2);
    $[0] = activeNavigationId;
    $[1] = nodes;
    $[2] = onItemClick;
    $[3] = onRetry;
    $[4] = statusLabelOverride;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[11] !== t1) {
    t2 = <>{t1}</>;
    $[11] = t1;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
}